import { InputTableLeftTabsProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { returnClassOfSpanTemplate } from '../../../../../../../utils/globals/tailwind'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import InputTableLeftColumnForm from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import ITHeaderText from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { getCurrencySymbol } from '../../../../../../../utils/globals/price'
import useOrderFinancialRowTypesDict from '../../../../../../../utils/hooks/orders/useOrderFinancialRowTypesDict'
import { financialRowTypesInversed } from '@teinor/erp/types/company/order/general'
import { CustomRenderString } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'

interface BuyReadOnlyHeaderFinancialRowsProps extends InputTableLeftTabsProps {}

const BuyReadOnlyHeaderFinancialRows: React.FC<BuyReadOnlyHeaderFinancialRowsProps> = ({ headerData, handleChange }) => {
    const { t } = useTwinTranslation()
    const financialRows = headerData.OrderFinancialRows
    const currencyHeaderId = headerData.CurrencyId
    const financialRowsSections: FormRender<any> = []
    const financialRowTypesDict = useOrderFinancialRowTypesDict()
    
    const items: TwinDictionary = { 0: { name: '%' }, 1: { name: getCurrencySymbol(currencyHeaderId) } }

    if (financialRows?.length) {
        for (let key in financialRows) {
            const financialRow = financialRows[key]
            const financialRowType = financialRow?.financialRowType === financialRowTypesInversed['discountForTotalFooter'] ? financialRowTypesInversed['discountWithCosts'] : financialRow?.financialRowType
            financialRowsSections.push({
                cols: 2,
                title: t('discountOrRecharge', 'Descuento o recargo'),
                elements: [
                    {
                        name: 'quantity',
                        component: 'Custom',
                        render: ({ value }) => <ITHeaderText label={t('quantity', 'Cantidad')} value={financialRow?.quantity + ' ' + items[financialRow?.calculationType].name} className={returnClassOfSpanTemplate(1)} />
                    },
                    {
                        name: key + '-financialRowType',
                        component: 'Custom',
                        render: ({ value }) => <ITHeaderText label={t('type', 'Tipo')} value={financialRowTypesDict[financialRowType].name} className={returnClassOfSpanTemplate(1)} />
                    },
                ]
            }, {
                cols: 1,
                title: '',
                elements: [
                    {
                        name: 'beforeTax',
                        component: 'Custom',
                        render: ({ value }) => <ITHeaderText label={t('taxes', 'Impuestos')} value={financialRow.beforeTax ? t('beforeTax', 'Antes de impuestos') : t('afterTax', 'Después de impuestos')} className={returnClassOfSpanTemplate(1)} />
                    },
                ]
            })
        }
    } else {
        financialRowsSections.push({
            title: '',
            cols: 1,
            elements: [
                {
                    name: 'noDiscountNoRecharges',
                    component: 'Custom',
                    render: () => <CustomRenderString value={t('noDiscountNoRecharges', 'Sin descuentos ni recargos')} />
                },
            ]
        })
    }
    const sections: FormRender<any> = [
        ...financialRowsSections,
    ]
    return (
        <InputTableLeftColumnForm form={sections} headerData={headerData} handleChange={handleChange} />
    )
}

export default BuyReadOnlyHeaderFinancialRows